// A nav row builds its left edge in flow (padding, icon, gap) while the search
// field draws the same edge absolutely, so both read from here or they drift.
export const NAV_ROW_PADDING_LEFT_CLASS = "pl-2"
export const NAV_ROW_ICON_SIZE_CLASS = "h-[1rem] w-[1rem]"
export const NAV_ROW_ICON_GAP_CLASS = "mr-3"
export const NAV_ROW_VERTICAL_PADDING_CLASS = "py-1"

export const SEARCH_HEIGHT_CLASS = "h-7"
export const SEARCH_ICON_POSITION_CLASS = "left-2"
export const SEARCH_TEXT_INSET_CLASS = "pl-9"

// The hint and the clear button share one width, so the field holds still
// between the empty and the typed state.
export const SEARCH_SUFFIX_SLOT_CLASS =
	"flex w-5 flex-none items-center justify-center"

export const TAILWIND_PX: Record<string, number> = {
	"pl-2": 8,
	"left-2": 8,
	"mr-3": 12,
	"h-[1rem]": 16,
	"w-[1rem]": 16,
	"pl-9": 36,
	"h-7": 28,
	"py-1": 4,
	"w-5": 20,
}

const px = (className: string) => {
	const value = TAILWIND_PX[className]
	if (value === undefined) throw new Error(`No px value for "${className}"`)
	return value
}

/** Where a nav row's icon starts, measured from the group's left edge. */
export const navIconInsetPx = () => px(NAV_ROW_PADDING_LEFT_CLASS)

/** Where a nav row's label starts: padding, then the icon, then the gap. */
export const navLabelInsetPx = () =>
	navIconInsetPx() +
	px(NAV_ROW_ICON_SIZE_CLASS.split(" ")[1] ?? "") +
	px(NAV_ROW_ICON_GAP_CLASS)

/** A nav row is its text line plus the padding above and below it. */
export const NAV_ROW_TEXT_LINE_PX = 20
export const navRowHeightPx = () =>
	NAV_ROW_TEXT_LINE_PX + px(NAV_ROW_VERTICAL_PADDING_CLASS) * 2

export const searchIconInsetPx = () => px(SEARCH_ICON_POSITION_CLASS)
export const searchTextInsetPx = () => px(SEARCH_TEXT_INSET_CLASS)
export const searchHeightPx = () => px(SEARCH_HEIGHT_CLASS)
